module.exports = __webpack_public_path__ + "img/lr5.45208f43.jpg";